import { render, staticRenderFns } from "./gifts.vue?vue&type=template&id=ad38b9be&"
import script from "./gifts.vue?vue&type=script&lang=js&"
export * from "./gifts.vue?vue&type=script&lang=js&"
import style0 from "./gifts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GiftsHeader: require('/home/runner/work/webpage/webpage/components/gifts/header/header.vue').default,GiftsTestPlans: require('/home/runner/work/webpage/webpage/components/gifts/test-plans/test-plans.vue').default,GiftsHowItWorks: require('/home/runner/work/webpage/webpage/components/gifts/how-it-works/how-it-works.vue').default,AreaFaqs: require('/home/runner/work/webpage/webpage/components/area/faqs/faqs.vue').default})
